import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=52f5db6f&"
import script from "./OverviewCard.vue?vue&type=script&lang=js&"
export * from "./OverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports